<template>
  <div style="margin-top: 2vh;">
    <el-dropdown trigger="click" class="international" @command="handleSetLanguage">
      <div>
        <i class="el-icon-s-unfold">Language</i>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item :disabled="lang==='pt'" command="pt">
          Português
        </el-dropdown-item>
        <el-dropdown-item :disabled="lang==='en'" command="en">
          English
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <x-markdown :md.sync='md' />
  </div>
</template>

<script>
import markdownComponent from '@/views/components/markdown'

export default {
  components: {
    'x-markdown': markdownComponent
  },
  data () {
    return {
      lang: 'en',
      md: 'empty',
      page: ''
    }
  },
  mounted () {
    this.reloadMd()
  },
  methods: {
    reloadMd () {
      if (this.$route.query.lang) {
        this.lang = this.$route.query.lang || 'en'
      }

      let route = this.$route.path
      const trimSlashes = str => str.replace(/^\/+|\/+$/g, '')
      this.page = trimSlashes(route)

      if (this.lang !== 'pt') {
        this.lang = 'en'
      }

      this.md = 'page/' + this.lang + '/' + this.page
    },

    handleSetLanguage (lang) {
      this.lang = lang
      this.$router.push({
        query: {
          lang: lang
        }
      })
      this.reloadMd()
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/policy/index.vue